/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

//

require('./bootstrap');

/**
 *
 */

import $ from 'jquery';
window.$ = window.jQuery = $;


/**
 *
 */

import AdminApp from './components/admin/App';
import FrontendApp from './components/frontend/App';
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import VueCookies from 'vue-cookies'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VueAxios from 'vue-axios';
import Axios from 'axios';
import VueRouter from 'vue-router';
import {adminRoutes,frontendRoutes} from './routes.js';
import VueSessionStorage from 'vue-sessionstorage';
import VueIconPicker from 'vue-icon-picker';
import ObjectToFD from 'vue-object-to-formdata';
import VueI18n from 'vue-i18n'
import {messages} from "./lang";
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import AOS from 'aos'
import 'aos/dist/aos.css'
import PerfectScrollbar from 'vue2-perfect-scrollbar'
import 'vue2-perfect-scrollbar/dist/vue2-perfect-scrollbar.css'
import VueEasyLightbox from 'vue-easy-lightbox'
import moment from 'moment'
import VueGtag from "vue-gtag";
import Vue from 'vue'
window.Vue = Vue;
// For more options see below
Vue.config.productionTip = false

// Añadir el script de Metricool
function loadScript(callback) {
    var head = document.getElementsByTagName("head")[0];
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "https://tracker.metricool.com/resources/be.js";
    script.onreadystatechange = callback;
    script.onload = callback;
    head.appendChild(script);
}

loadScript(function() {
    window.beTracker && beTracker.t({ hash: "f931d9aa40be22c8c0aadb24cb61cb5a" });
});

Vue.use(VueRouter);
Vue.use(VueAxios, Axios);
Vue.use(VueSessionStorage);
Vue.use(VueCookies);
Vue.use(VueIconPicker);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(ObjectToFD);
Vue.prototype.moment = moment;
const optionsSwal = {
    confirmButtonColor: '#41b882',
    cancelButtonColor: '#41b882' // #ff7674
};
Vue.use(VueSweetalert2, optionsSwal)
Vue.use(VueI18n);
Vue.use(PerfectScrollbar);
Vue.use(VueEasyLightbox);

const i18n = new VueI18n({
    locale: 'es',
    availableLocales: ['es','en','ca'],
    fallbackLocale: 'es',
    messages,
});
window.axios = require('axios');
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;
window.axios.defaults.baseURL = process.env.APP_URL;
if (Vue.$cookies.isKey('jwt')) {
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${Vue.$cookies.get('jwt')}`;
} else {
    delete window.axios.defaults.headers.common["Authorization"];
}
if(document.getElementById('app-admin')) {
    /*if (!sessionStorage.getItem('jwt')) {
        location.href='/login';
    }*/
    Vue.component('admin-partial-sidebar', require('./components/admin/partials/Sidebar').default);
    Vue.component('admin-partial-navbar', require('./components/admin/partials/Navbar').default);
    Vue.component('admin-partial-footer', require('./components/admin/partials/Footer').default);
    //Vue.component('my-editor', require('./components/Custom/MyEditor').default);
    const $router = new VueRouter({
        mode: 'history',
        routes: adminRoutes,
        scrollBehavior (to, from, savedPosition) {
            return { x: 0, y: 0 }
        }
    });
    const appAdmin = new Vue({
        el: '#app-admin',
        router: $router,
        render: h => h(AdminApp),
        i18n
    });
}
if(document.getElementById('app-frontend')) {
    Vue.component('partial-navbar', require('./components/frontend/partials/Navbar').default);
    Vue.component('partial-footer', require('./components/frontend/partials/Footer').default);
    Vue.component('pagination', require('./components/frontend/partials/Pagination').default);
    Vue.component('list-artworks', require('./components/frontend/artworks/List').default);
    Vue.component('modal-frontend', require('./components/frontend/partials/Modal').default);
    let locale = ($cookies.isKey('i18n'))?$cookies.get('i18n') : i18n.locale
    const $router = new VueRouter({
        mode: 'history',
        routes: frontendRoutes[locale],
        scrollBehavior (to, from, savedPosition) {
            return { x: 0, y: 0 }
        }
    });
    $router.afterEach((to, from) => {
        if (window.beTracker) {
            beTracker.t({ hash: "f931d9aa40be22c8c0aadb24cb61cb5a", url: to.fullPath });
        }
    });
    $router.beforeEach(function(to, from, next) {
        if(to.name === from.name) $router.go(to.fullPath);
        const nearestWithTitle = to.matched.slice().reverse().find(r => r.meta && r.meta.title);
        const nearestWithMeta = to.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
        const previousNearestWithMeta = from.matched.slice().reverse().find(r => r.meta && r.meta.metaTags);
        if(nearestWithTitle) {
            document.title = i18n.t(`hi.${nearestWithTitle.meta.title}`, locale);
        } else if(previousNearestWithMeta) {
            document.title = i18n.t(`hi.${previousNearestWithMeta.meta.title}`, locale);
        }
        Array.from(document.querySelectorAll('[data-vue-router-controlled]')).map(el => el.parentNode.removeChild(el));
        if(!nearestWithMeta) return next();
        nearestWithMeta.meta.metaTags.map(tagDef => {
            const tag = document.createElement('meta');
            Object.keys(tagDef).forEach(key => {
                tag.setAttribute(key, i18n.t(`hi.${tagDef[key]}`, locale));
            });
            tag.setAttribute('data-vue-router-controlled', '');
            return tag;
        })
            .forEach(tag => document.head.appendChild(tag));
        next();
    });
    Vue.use(VueGtag, {
        config: {
            id: "G-H053LFKHS0",
        }
    },
        $router);
    const appFrontend = new Vue({
        el: '#app-frontend',
        router: $router,
        render: h => h(FrontendApp),
        i18n,
        data(){
            return {
                max_img: 2,
            }
        },
        mounted() {
            AOS.init()
        }
    });
}
